import React, { useState, useRef, useEffect } from 'react';
import Button from '../../../components/ui/button';
import { ChevronDown, Check } from 'lucide-react';

const StepNavigationDropdown = ({ 
	steps, 
	currentStep, 
	onStepChange, 
	stepValidations,
	disabled = false 
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);
	
	// Get current step data
	const currentStepData = steps[currentStep];
	
	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);
	
	if (!currentStepData) {
		return (
			<Button
				variant="outline"
				className="min-w-[200px] justify-between border-gray-300 text-left font-normal"
				disabled={true}
			>
				<span className="text-sm">Loading...</span>
				<ChevronDown className="ml-2 h-4 w-4 text-gray-400" />
			</Button>
		);
	}

	const handleStepSelect = (index) => {
		onStepChange(index);
		setIsOpen(false);
	};

	return (
		<div className="relative" ref={dropdownRef}>
			<Button
				variant="outline"
				className="min-w-[200px] justify-between border-gray-300 text-left font-normal"
				disabled={disabled}
				onClick={() => setIsOpen(!isOpen)}
			>
				<div className="flex items-center gap-2">
					{currentStepData.icon && (
						<currentStepData.icon className="h-4 w-4 text-gray-600" />
					)}
					<span className="text-sm font-medium">
						Step {currentStep + 1}: {currentStepData.title}
					</span>
				</div>
				<ChevronDown className={`ml-2 h-4 w-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
			</Button>
			
			{isOpen && (
				<div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50">
					{steps.map((step, index) => {
						const validation = stepValidations[step.id];
						const isComplete = validation?.isComplete || false;
						const isCurrent = index === currentStep;

						return (
							<button
								key={step.id}
								onClick={() => handleStepSelect(index)}
								className={`
									w-full px-3 py-2 text-left hover:bg-gray-50 transition-colors
									${isCurrent ? 'bg-gray-50' : ''}
									border-b border-gray-100 last:border-b-0
								`}
							>
								<div className="flex items-center gap-2">
									<span className="text-sm">{index + 1}.</span>
									<span className="text-sm truncate flex-1">{step.title}</span>
									{isComplete && <Check className="h-3 w-3 text-green-600" />}
								</div>
							</button>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default StepNavigationDropdown;